import { NgModule } from '@angular/core';
import {
  CmsConfig,
  Config,
  FeaturesConfig,
  PageMetaConfig,
  provideConfig,
  SiteContextConfig,
  StateConfig,
  StateTransferType,
} from 'haba-core';
import { layoutConfig, mediaConfig, PWAModuleConfig } from 'haba-storefrontlib';
import { environment } from '../../environments/environment';
import { HomepageComponent } from '../contentful/homepage/homepage.component';
import { habaI18nConfig } from './i18n.config';
import { ErrorPageComponent } from '../contentful/error-page/error-page.component';
import { CheckoutConfig } from 'haba-featurelibs/checkout/root';
import { DeliveryEstimateConfig } from 'haba-emporix';
import { habaLayoutConfig } from './layout.config';

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    provideConfig(layoutConfig as Config),
    provideConfig(habaLayoutConfig as Config),
    provideConfig(mediaConfig as Config),
    provideConfig(habaI18nConfig),
    provideConfig({
      backend: {
        occ: {
          baseUrl: environment.occ.baseUrl,
          prefix: environment.occ.prefix,
        },
      },
    }),
    provideConfig(<SiteContextConfig>{
      context: {},
    }),
    provideConfig(<FeaturesConfig>{
      features: {
        level: '4.1',
      },
    }),
    provideConfig(<DeliveryEstimateConfig>{
      deliveryEstimate: {
        format: 'dateRange',
      },
    }),
    provideConfig(<PageMetaConfig>{
      pageMeta: {
        canonicalUrl: {
          forceTrailingSlash: false,
        },
      },
    }),
    provideConfig((<PWAModuleConfig>{
      pwa: {
        enabled: false,
      },
    }) as Config),
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ContentfulComponent: {
          component: HomepageComponent,
        },
        ErrorPageComponent: {
          component: ErrorPageComponent,
        },
      },
    }),
    provideConfig(<StateConfig>{
      state: {
        ssrTransfer: {
          keys: {
            product: StateTransferType.EXCLUDE_STATE,
          },
        },
      },
    }),
    provideConfig(<CmsConfig>{
      featureModules: {
        FormFieldsModule: {
          module: () =>
            import('../base-components/form-fields/form-fields.module').then(
              (m) => m.FormFieldsModule
            ),
        },
        StyleguideModule: {
          module: () => import('../@styleguide/styleguide.module').then((m) => m.StyleguideModule),
        },
        ContentModule: {
          module: () => import('../features/content/content.module').then((m) => m.ContentModule),
          cmsComponents: ['CMSTabParagraphContainer'],
        },
      },
    }),
    provideConfig({
      routing: {
        routes: {
          wishlist: { paths: ['wishlist'] },
          notAvailable: { paths: ['not-available'] },
          styleguide: { paths: ['styleguide'] },
        },
      },
    }),
    provideConfig((<CheckoutConfig>{
      checkout: {
        guest: true,
      },
    }) as Config),
  ],
})
export class SpartacusConfigurationModule {}
